interface IEnvironment {

    VIDEOSDK_ANALYTICS: boolean,
    VIDEO_CALL_MAX_DURATION: number,
    PAYMENT_SERVICE: 'KONNECT' | 'PAYME',
    API_HOST_NAME: string,
    PORT: number,
    API_URL: string,
    STORAGE_ENDPOINT: string,
    DOMAINE_NAME: string,
    API_SSL: boolean,
    ENV: 'production' | 'development',
    addsPannels: boolean,
    SECOND_OPINION_API_URL?: string;
    JSP_URL:string;
    JSP_HOST_NAME:string;
    GOOGLE_REDIRECT_URI?:string;
}

export class Environment implements IEnvironment {

    VIDEOSDK_ANALYTICS: boolean;
    VIDEO_CALL_MAX_DURATION: number;
    PAYMENT_SERVICE: 'KONNECT' | 'PAYME';
    API_HOST_NAME: string;
    PORT: number;
    API_URL: string;
    STORAGE_ENDPOINT: string;
    DOMAINE_NAME: string;
    API_SSL: boolean;
    JSP_URL:string;
    JSP_HOST_NAME:string;
    ENV: 'production' | 'development';
    VIDEOSDK_API_URL: string = 'https://api.videosdk.live';
    addsPannels: boolean;
    SECOND_OPINION_API_URL?: string;
    GOOGLE_REDIRECT_URI?:string;
    constructor(other: IEnvironment) {

        this.VIDEOSDK_ANALYTICS = other.VIDEOSDK_ANALYTICS;
        this.VIDEO_CALL_MAX_DURATION = other.VIDEO_CALL_MAX_DURATION;
        this.PAYMENT_SERVICE = other.PAYMENT_SERVICE;
        this.API_HOST_NAME = other.API_HOST_NAME;
        this.PORT = other.PORT;
        this.API_URL = other.API_URL;
        this.STORAGE_ENDPOINT = other.STORAGE_ENDPOINT;
        this.DOMAINE_NAME = other.DOMAINE_NAME;
        this.API_SSL = other.API_SSL;
this.JSP_HOST_NAME=other.JSP_HOST_NAME;
        this.ENV = other.ENV;
        this.addsPannels = other.addsPannels;
        this.SECOND_OPINION_API_URL = other.SECOND_OPINION_API_URL;
        this.JSP_URL=other.JSP_URL;
        this.GOOGLE_REDIRECT_URI=other.GOOGLE_REDIRECT_URI
    }

    getVideoSDKApiHostName(): string {
        return new URL(this.VIDEOSDK_API_URL).hostname;
    }
}